import { create } from '~/utils/store/createStore';

interface ThinkingStepsSidebarState {
  isOpen: boolean;
  activeConversationId?: string;
  activeRequestId?: string;
}

interface ThinkingStepsSidebarActions {
  setIsOpen: (isOpen: boolean) => void;
  resetSidebar: () => void;
  openForTask: ({
    conversationId,
    requestId,
  }: {
    conversationId?: string;
    requestId?: string;
  }) => void;
  closeSidebar: () => void;
}

type ThinkingStepsSidebarStore = ThinkingStepsSidebarState &
  ThinkingStepsSidebarActions;

export const useThinkingStepsSidebar = create<ThinkingStepsSidebarStore>(
  set => ({
    isOpen: false,
    activeConversationId: undefined,
    activeRequestId: undefined,
    setIsOpen: (isOpen: boolean) => set({ isOpen }),
    resetSidebar: () => set({ isOpen: false }),
    openForTask: ({ conversationId, requestId }) =>
      set({
        isOpen: true,
        activeConversationId: conversationId,
        activeRequestId: requestId,
      }),
    closeSidebar: () =>
      set({
        isOpen: false,
        activeConversationId: undefined,
        activeRequestId: undefined,
      }),
  })
);
